export function removeNbspParagraphs(input: string): string {
  if (!input || typeof input !== 'string') return ""
  const regex = /<p>(\s|&nbsp;)*<\/p>/g;
  return input?.replace(regex, "");
}
